import { getErrorMessage } from '@/shared/lib'
import Config from '../../../../shared/config/config'
import { getLocalConfig, saveLocalConfig } from '@/shared/config/db/configDb'
import { getConfigService } from '@/shared/getContainer/getConfigService'

export class ConfigRepositoryToya {
    lastUpdateConfigFailTime = 0
    updateConfigFailAttempts = 0
    private static _instance: ConfigRepositoryToya

    public static get Instance() {
        return (this._instance = new ConfigRepositoryToya())
    }

    getLocalConfig = (): Config | null | undefined => {
        const jsonLocalConfig = getLocalConfig()
        if (jsonLocalConfig) {
            try {
                const configObj = new Config(jsonLocalConfig)
                return configObj
            } catch (error) {
                getErrorMessage('getLocalConfig', error)
                throw error
            }
        }
    }

    getRemoteConfig = async (): Promise<Config | null | undefined> => {
        //if there was not previous update config fails or required time for the next attempt has elapsed
        if (!this.lastUpdateConfigFailTime) {
            try {
                const getApiConfig = await getConfigService()
                const remoteConfig = await getApiConfig()
                if (remoteConfig) {
                    remoteConfig.getConfigSaveTime()
                    return remoteConfig
                } else {
                    //start measure time since last update config fail
                    this.updateConfigFailAttempts += 1
                    // actual time in seconds
                    this.lastUpdateConfigFailTime = Math.floor(
                        Date.now() / 1000
                    )
                }
                return null
            } catch (error) {
                getErrorMessage('getRemoteConfig', error)
                throw error
            }
        } else {
            this.handleUpdateConfigFail()
        }
    }

    takeConfigIfNeed = async (): Promise<void | Config> => {
        //check if config is in LS and get it if it is not
        const localConfig = this.getLocalConfig()
        if (!localConfig?.configVersion) {
            try {
                const remoteConfig = await this.getRemoteConfig()
                if (remoteConfig) {
                    saveLocalConfig(remoteConfig)
                    return remoteConfig
                }
            } catch (error) {
                getErrorMessage('takeConfigIfNeed', error)
                throw error
            }
        }
    }

    checkConfigAndUpdateIfNeed = async (): Promise<boolean> => {
        const localConfig = this.getLocalConfig()
        if (localConfig) {
            if (localConfig.checkTimeIfConfigNeedsUpdate()) {
                try {
                    const remoteConfig = await this.getRemoteConfig()

                    if (remoteConfig) {
                        saveLocalConfig(remoteConfig)
                        return true
                    }
                } catch (error) {
                    getErrorMessage('checkConfigAndUpdateIfNeed', error)
                    throw error
                }
            }
        }
        return false
    }

    handleUpdateConfigFail = (): void => {
        const localConfig = this.getLocalConfig()

        if (localConfig) {
            // check if maximum number of update config attempts exceeded
            if (
                this.updateConfigFailAttempts >=
                localConfig.tvUpdateIntervals.configUpdateMaxRetries
            ) {
                // maximum number of update config attempts exceeded
                this.lastUpdateConfigFailTime =
                    localConfig.tvUpdateIntervals.configUpdateIntervalOnSuccess
                this.updateConfigFailAttempts = 0
            }
            //update time since last update config fail
            const secondsSinceLastGetConfigFail =
                Math.floor(Date.now() / 1000) - this.lastUpdateConfigFailTime

            if (
                secondsSinceLastGetConfigFail >
                localConfig.tvUpdateIntervals.configUpdateIntervalOnError
            ) {
                //reset lastGetConfigFailTime to retake get config attempt
                this.lastUpdateConfigFailTime = 0
            }
        }
    }
}
